import { render } from "./LoadsTable.vue?vue&type=template&id=0b116f5a&scoped=true&ts=true"
import script from "./LoadsTable.vue?vue&type=script&lang=ts"
export * from "./LoadsTable.vue?vue&type=script&lang=ts"

import "./LoadsTable.vue?vue&type=style&index=0&id=0b116f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b116f5a"]])

export default __exports__